const grid = {
  formulaBar: "Строка формул",
  bold: "Жирный",
  italic: "Курсив",
  cellColor: "Цвет ячейки",
  textColor: "Цвет текста",
  addColumn: "Добавить столбец",
  removeColumn: "Удалить столбец",
  addRow: "Добавить строку",
  removeRow: "Удалить строку",
  freezeColumn: "Закрепить столбец",
  undo: "Отменить",
  redo: "Повторить",
  exportCSV: "Экспорт CSV",
  addSheet: "Добавить лист",
  deleteSheet: "Удалить лист",
  duplicateSheet: "Дублировать лист",
} as const;
export default grid;
